export default "/images/icon_key_fast.svg?95157def667d0b8853d5b0f46be3b236";